import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 text-foreground-700">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="font-heading text-lg text-foreground-900 mb-4">Sugargoo Sheet</h4>
            <p className="text-sm leading-relaxed text-foreground-600 mb-4">
              Your independent resource for Sugargoo spreadsheets, product finds, buying guides, and shopping tips.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/sugargoo-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-review-is-legit" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-shipping-cost-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Shipping Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Sugargoo Spreadsheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200">
          <p className="text-xs text-foreground-500 leading-relaxed text-center">
            <strong>Disclaimer:</strong> Sugargoo Sheet is an independent information platform and is not affiliated with Sugargoo.
            All product links redirect to our partner website. We help shoppers discover the best Sugargoo spreadsheet finds.
          </p>
          <p className="text-xs text-foreground-400 text-center mt-3">
            &copy; {new Date().getFullYear()} Sugargoo Sheet. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}